import { render } from "./PopUpQuestionFlashSoluce.vue?vue&type=template&id=738c6479"
import script from "./PopUpQuestionFlashSoluce.vue?vue&type=script&lang=js"
export * from "./PopUpQuestionFlashSoluce.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__